import React from 'react';
import { useTranslation } from 'react-i18next';
import { ReactComponent as WarningIcon } from 'assets/icons/profile-page-icons/warning-triangle.svg';

import * as S from './OutputLockWarning.styled';

export const OutputLockWarning: React.FC<{ isSmallSize?: boolean }> = ({ isSmallSize }) => {
  const { t } = useTranslation();

  return (
    <S.Wrapper $isSmallSize={isSmallSize}>
      <WarningIcon />
      <S.Text $isSmallSize={isSmallSize}>{t('popup.wontBeAble')}</S.Text>
    </S.Wrapper>
  );
};
